var _style, _defs, _g, _g2, _g3, _path, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowRequestedUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.1 52.3",
    style: {
      enableBackground: "new 0 0 56.1 52.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CFD1D2;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2y{fill:#FFAE1E;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 24.2,
    cy: 24.2,
    r: 24.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081647791246064276110000005889363163730285729_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24.2,
    cy: 24.2,
    r: 24.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.2,13.2c3.1,0,5.7,2.5,5.7,5.7s-2.5,5.7-5.7,5.7s-5.7-2.5-5.7-5.7S21.1,13.2,24.2,13.2 M24.2,11.2 c-4.2,0-7.7,3.4-7.7,7.7c0,4.2,3.4,7.7,7.7,7.7s7.7-3.4,7.7-7.7C31.9,14.6,28.4,11.2,24.2,11.2L24.2,11.2z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.2,13.2c3.1,0,5.7,2.5,5.7,5.7s-2.5,5.7-5.7,5.7s-5.7-2.5-5.7-5.7S21.1,13.2,24.2,13.2 M24.2,11.2 c-4.2,0-7.7,3.4-7.7,7.7c0,4.2,3.4,7.7,7.7,7.7s7.7-3.4,7.7-7.7C31.9,14.6,28.4,11.2,24.2,11.2L24.2,11.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.9,24.5h-1.5c-5.5,0-10,4.5-10,10v11.3c0.7,0.3,1.3,0.6,2,0.9V34.5c0-4.4,3.6-8,8-8h1.5c4.4,0,8,3.6,8,8 v12.2c0.7-0.3,1.3-0.6,2-0.9V34.5C34.9,29,30.4,24.5,24.9,24.5z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2y",
    cx: 43.5,
    cy: 39.7,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.5,31c4.8,0,8.7,3.9,8.7,8.7s-3.9,8.7-8.7,8.7c-4.8,0-8.7-3.9-8.7-8.7S38.7,31,43.5,31 M43.5,27.1 c-6.9,0-12.6,5.6-12.6,12.6s5.6,12.6,12.6,12.6s12.6-5.6,12.6-12.6S50.5,27.1,43.5,27.1L43.5,27.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 43.5,
    cy: 39.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 47.9,
    cy: 39.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 39.2,
    cy: 39.7,
    r: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowRequestedUser);
export default __webpack_public_path__ + "static/media/yellow_requested_user.9124c4f156add229f36461b57af35de1.svg";
export { ForwardRef as ReactComponent };